import {
  mapFieldsCareService,
  mapFieldsHealth,
  mapFieldsCareLevelCalculator,
} from '@/store/mapFields';
import { formatNumber } from '@/helpers/formatter';

import careServiceFacts, { serviceInfos } from '@/content/services/CareService/CareServiceFacts';

export default {
  computed: {
    ...mapFieldsCareService([
      'careService',
      'careServiceFacts',
      'careServiceWizardIsFinished',
      'userInputValue',
      'careServiceCareLevel',
    ]),
    ...mapFieldsHealth(['careLevel', 'careLevelDate', 'healthDataLoaded']),
    ...mapFieldsCareLevelCalculator(['calculatedCareLevel']),

    currentCareLevelIsCalculated() {
      return this.careServiceCareLevel === this.calculatedCareLevel;
    },

    approvedValueInPercent() {
      return (100 / this.totalPerYear) * this.approvedValue;
    },

    desiredValueInPercent() {
      if (this.countDesiredValues === 0) {
        return 0;
      }

      return (100 / this.totalPerYear) * this.desiredValue;
    },

    approvedValue() {
      return this.calculateAmount(2) + this.calculateAmount(3);
    },

    desiredValue() {
      if (this.countDesiredValues === 0) {
        return 0;
      }

      return this.calculateAmount(1) + this.calculateAmount(2);
    },

    countDesiredValues() {
      let count = 0;
      Object.values(this.careServiceFacts).forEach((c) => {
        if (c === 1) {
          count += 1;
        }
      });
      return count;
    },

    /**
     * Errechnete Beträge für Pflegegeld
     * und Sachleistungen, basieren auf die Eingaben
     * aus dem Wizard.
     */
    calculatedBasics() {
      let anteil_s2 = 0;
      let anteil_pg = 0;
      Object.keys(this.careService).map((c) => {
        if (c !== 'switcherRow-3') {
          anteil_s2 += this.t2Map[this.careService[c][0]];
        }
      });

      /**
       * Definition: Nichts ausgewählt = 100% Pflegegeld
       *
       * Der User wünscht keine Unterstützung in den Kategorien (Wizard)
       * und kann deshalb 100% Pflegegeld in Anspruch nehmen!
       */
      if (anteil_s2 === 0) {
        return {
          pflegegeld: {
            amount: this.getFact('pflegegeld').amount,
            percent: 100,
          },
          pflegesachleistungen: {
            amount: 0,
            percent: 0,
          },
        };
      }

      anteil_s2 = 100 / anteil_s2;

      Object.keys(this.careService).map((c) => {
        if (c !== 'switcherRow-3') {
          anteil_pg +=
            this.t2Map[this.careService[c][0]] *
            anteil_s2 *
            (this.t1Map[this.careService[c][1]] / 2);
        }
      });

      const sachleistungenPercent = 100 - anteil_pg;

      return {
        pflegegeld: {
          amount: this.getFact('pflegegeld').amount * (anteil_pg / 100),
          percent: anteil_pg,
        },
        pflegesachleistungen: {
          amount: this.getFact('pflegesachleistungen').amount * (sachleistungenPercent / 100),
          percent: sachleistungenPercent,
        },
      };
    },

    ourRecommendation() {
      if (!this.careServiceWizardIsFinished) {
        return false;
      }

      const { pflegegeld, pflegesachleistungen } = this.calculatedBasics;
      if (pflegesachleistungen.percent === 100) {
        return 'pflegesachleistungen';
      }
      if (pflegegeld.percent === 100) {
        return 'pflegegeld';
      }
      return 'kombinationsleistung';
    },

    totalPerYear() {
      let value = 0;

      Object.keys(this.getCareLevelFact()).map((c) => {
        /**
         * Alle Leistungen werden aufaddiert, je nach dem, ob sie
         * monatlich oder jährlich gezahlt werden.
         * Pflegegeld wird nicht berücksichtigt, da
         * Pflegesachleistungen der höhere Betrag ist. Und wenn man
         * 100% Pflegesachleistungen bezieht, kann das Pflegegeld
         * nur 0% betragen.
         */
        if (c !== 'pflegegrad' && c !== 'pflegegeld') {
          value +=
            this.getFact(c).payout === 'monthly'
              ? this.getFact(c).amount * 12
              : this.getFact(c).amount;
        }
      });

      return value;
    },

    userInputFromSlider() {
      const careLevel = this.careServiceCareLevel || this.careLevel;
      const getCareLevelFact = careServiceFacts.filter((c) => c.pflegegrad === careLevel)[0];

      return {
        pflegegeld: {
          amount: getCareLevelFact['pflegegeld'] * (parseInt(this.userInputValue) / 100),
          percent: parseInt(this.userInputValue),
        },
        pflegesachleistungen: {
          amount:
            getCareLevelFact['pflegesachleistungen'] *
            ((100 - parseInt(this.userInputValue)) / 100),
          percent: 100 - parseInt(this.userInputValue),
        },
      };
    },
  },
  data() {
    return {
      // https://miro.com/app/board/o9J_lAozMeo=/?moveToWidget=3074457360842528050&cot=14
      t1Map: [2, 1, 0],
      // https://miro.com/app/board/o9J_lAozMeo=/?moveToWidget=3074457360842528011&cot=14
      t2Map: [4, 3, 2, 1],
      usingRecommendation: true,
      formatNumber,
      el: 'c-careServiceBudgetPackage',
    };
  },
  methods: {
    /**
     * Jedes Element kann die Zustände 0, 1 und 2 annehmen als Parameter "userSelection"
     *
     * 0: User hat NICHT diese Leistung
     * 1: User WÜNSCHT sich diese Leistung
     * 2: User HAT diese Leistung
     */
    calculateAmount(userSelection) {
      let value = 0;

      Object.keys(this.careServiceFacts).map((c) => {
        if (this.careServiceFacts[c] === userSelection && c !== 'pflegegrad') {
          if (c === 'kombinationsleistung') {
            value +=
              this.userInputFromSlider.pflegegeld.amount * 12 +
              this.userInputFromSlider.pflegesachleistungen.amount * 12;
          } else {
            const { amount, payout } = this.getFact(c);

            let multiplicator = 1;
            // if (c === 'kurzzeitpflege' && this.careServiceFacts['verhinderungspflege'] > 0) {
            //   multiplicator = 0.454;
            // }
            value += payout === 'monthly' ? amount * 12 : amount * multiplicator;
          }
        }
      });

      return value;
    },

    getCareLevelFact() {
      const pflegegrad = this.careServiceCareLevel || this.careLevel;
      return careServiceFacts.filter((c) => c.pflegegrad === pflegegrad)[0];
    },

    getFact(id) {
      return {
        amount: this.getCareLevelFact()[id],
        payout: this.payoutType(id),
      };
    },

    payoutType(id) {
      const match = serviceInfos.filter((s) => s.label === id)[0];
      return match.payout;
    },
  },
};
